/*
 * ReportingDashboardPanel Messages
 *
 * This contains all the text for the ReportingDashboardPanel container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.ReportingDashboardPanel';

export default defineMessages({
  reportingPanel: {
    id: `${scope}.reportingPanel`,
    defaultMessage: 'Reporting panel',
  },
  addOrganization: {
    id: `${scope}.addOrganization`,
    defaultMessage: '+ Add Organization',
  },
});
